import { useMemo } from 'react';
import { useArticlesSubscriptionsContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesSubscriptions';
import { selectAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters';
import type { ISubscriptionAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';

export const useAdapterConfig = (): ISubscriptionAdapter => {
  const context = useArticlesSubscriptionsContext();

  return useMemo(() => {
    return selectAdapter({
      themes: context.themes,
      currentRegion: context.currentRegion,
      currentProduct: context.currentProduct,
      currentMarket: context.currentMarket,
      subscribableRegionIds: context.subscribableRegionIds,
    });
  }, [
    context.themes,
    context.currentRegion,
    context.currentProduct,
    context.currentMarket,
    context.subscribableRegionIds,
  ]);
};
